import React from 'react';

import { ajaxGet } from 'common/ajax';
import FEATURE_FLAGS from 'components/CRM/Common/featureFlags';
import { getIsFeatureFlagActive } from 'components/CRM/Common/hooks/useIsFeatureFlagActive';
import { currentUserService } from 'subjects/common/CurrentUserService';

import { sidebarToggleClicked$ } from '../NavMenu/NavMenu';
import CallOverlay from '../Talkdesk/CallOverlay';
import Talkdesk from '../Talkdesk/Talkdesk';
import UserDropDown from './UserDropDown';

const prodEnvironments = ['PROD', 'PREPROD', 'VNEXT'];
const lowerEnvDisplayNames = {
    NEWDEV: 'DEV',
    NEWQA: 'QA',
    NEWERUAT: 'UAT',
    FACETS: 'FACETS',
    DEVELOPMENT: 'LOCAL DEV',
};

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.subscriptions = [];

        this.state = {
            toggle: true,
            crmFeatureFlags: null,
            environment: null,
            loadingEnvInfo: true,
        };
    }

    componentDidMount() {
        this.subscriptions.push(
            currentUserService.get().subscribe((user) => {
                if (user?.crmFeatureFlags) {
                    this.setState({ crmFeatureFlags: user.crmFeatureFlags });
                }
            }),
        );

        const envSubscription = ajaxGet('/api/Config/ConfigVariables').subscribe({
            next: ({ response }) => {
                this.setState({ environment: response.environment, loadingEnvInfo: false });
            },
            error: (e) => {
                console.error(e);
                this.setState({ loadingEnvInfo: false });
            },
        });
        this.subscriptions.push(envSubscription);
    }

    componentWillUnmount() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }

    toggleClick = () => {
        this.setState((prevState) => {
            sidebarToggleClicked$.next(!prevState.toggle);
            return { toggle: !prevState.toggle };
        });
    };

    render() {
        const isProdEnvironment = prodEnvironments.includes(this.state.environment?.toUpperCase());
        const cssClass = isProdEnvironment || this.state.loadingEnvInfo ? 'main-header' : 'main-header-lower-env';
        return (
            <>
                <div
                    className={cssClass}
                    id='header-section'
                    data-testid='header'
                >
                    <div className={`logo ${this.state.toggle ? 'logo-toggle-on' : 'logo-toggle-off'}`}>
                        <a
                            href='/'
                            className='main-logo'
                        >
                            <img
                                src='/img/logo.png'
                                alt='logo'
                                width='40px'
                                height='40px'
                            />
                        </a>
                    </div>
                    <ul className='header-list'>
                        <li
                            className={`float-left header-style icon-menu ${
                                this.state.toggle ? 'hamburger-toggle-on' : 'hamburger-toggle-off'
                            }`}
                            id='hamburger'
                            onClick={this.toggleClick}
                        ></li>
                        <li className={'header-style float-left'}>
                            <CallOverlay />
                        </li>
                        <li className='header-style float-right user'>
                            {!(isProdEnvironment || this.state.loadingEnvInfo) && (
                                <p>
                                    Environment:{' '}
                                    {lowerEnvDisplayNames[this.state.environment?.toUpperCase()] || 'UNKNOWN'}
                                </p>
                            )}
                            <UserDropDown
                                talkdeskEnabled={getIsFeatureFlagActive(
                                    this.state.crmFeatureFlags,
                                    FEATURE_FLAGS.TALKDESK_INTEGRATION,
                                )}
                            />
                        </li>
                    </ul>
                </div>
                <Talkdesk crmFeatureFlags={this.state.crmFeatureFlags} />
            </>
        );
    }
}
